exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-toolbar-widget{display:inline-flex;align-items:stretch}.ba-toolbar-widget__separator{width:1em;height:100%;display:inline-block;position:relative}.ba-toolbar-widget__separator:after{content:\"\";height:100%;width:1px;border-right:1px solid;position:absolute;left:0;right:0;margin:auto}.ba-toolbar-widget__item{display:flex;justify-content:center;align-items:center}.ba-toolbar-widget__item .ba-common-button{margin-right:0}.ba-toolbar-widget.is-border{border:1px solid #c0bfc0}.ba-toolbar-widget__separator:after{border-color:#c0bfc0}", ""]);

// exports
exports.locals = {
	"ToolbarWidget": "\"ba-toolbar-widget\""
};